import React from "react";
import "./DeletePopupModal.css";
import { FaTimes } from "react-icons/fa";

const DeletePopupModal = ({
  title,
  subtitle,
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}) => {
  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-container">
        <div className="delete-modal-header">
          {title}
          <div className="modal-close-icon" onClick={onClose}>
            <FaTimes />
          </div>
        </div>
        <div className="delete-modal-body">{subtitle}</div>
        <div className="delete-modal-actions">
          <button
            className="delete-btn-yes"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? <span className="spinner" /> : "Yes"}
          </button>
          <button
            className="delete-btn-no"
            onClick={onClose}
            disabled={isLoading}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePopupModal;
